import { render, staticRenderFns } from "./UCIrvineChem1LCELN1OIPlan.vue?vue&type=template&id=6a74b860&"
import script from "./UCIrvineChem1LCELN1OIPlan.vue?vue&type=script&lang=js&"
export * from "./UCIrvineChem1LCELN1OIPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer,VForm,VRow})
